import
{
  ChangeDetectorRef,
  Component,
  HostListener,
  Input,
  OnDestroy,
  OnInit,
} from "@angular/core";
import { UntypedFormBuilder, UntypedFormGroup, Validators } from "@angular/forms";
import { Router } from "@angular/router";
import { CustomerPasswordResetRequestDTO } from "@dto";
import { TranslateService } from "@ngx-translate/core";
import { PasswordRecoveryService } from "@service/session/password-recovery/password-recovery.service";
import { WindowRefService } from "@service/window-service/window-ref.service";
import { LoginError } from "../../../../../utils/login.error";
import { showAfterSecond } from "../../../../../utils/utilsFunctions";
import { PopupService } from "../../../../service/popup/popup.service";
import { CustomValidators } from "../../../../../utils/custom.validators";
import { UrlTranslateService } from '@service/helpers/url-translate.service';

enum ControlNames
{
  EMAIL = "email",
}

@Component({
    selector: "app-recovery-password-popup",
    templateUrl: "./recovery-password-popup.component.html",
    styleUrls: ["./recovery-password-popup.component.scss"],
    standalone: false
})
export class RecoveryPasswordPopupComponent implements OnInit, OnDestroy
{
  public readonly ControlNames = ControlNames;
  @Input() public emailPlaceholder: string = "Adres e-mail";
  @Input() private name: string = "recovery";
  private defaultButtonText = "Zresetuj hasło";
  private readonly buttonTextSuccess = "Wysłano!";

  public buttonText = this.defaultButtonText;
  public formGroup: UntypedFormGroup;
  public error: any = null;
  public submitted = false;
  public successMsg = "";
  public isLoading = false;
  public showForm: boolean = false;
  public isSend: boolean = false;
  public savedEmail: string;
  public loaded = [];
  constructor(
    private passwordRecoveryService: PasswordRecoveryService,
    private router: Router,
    private windowRef: WindowRefService,
    private translate: TranslateService,
    private changeDet: ChangeDetectorRef,
    private formBuilder: UntypedFormBuilder,
    private popupService: PopupService,
    public urlTranslateService: UrlTranslateService,
  )
  {
    this.emailPlaceholder = this.translate.instant("cart.addressField.email");
    this.defaultButtonText = this.translate.instant("login.resetPassword");
  }

  public ngOnInit(): void
  {
    this.buildForm();

    this.popupService.reserveName(this.name);
  }

  ngOnDestroy()
  {
    this.popupService.clearName(this.name);
  }

  public openModal(disableReload?: boolean): void
  {
    this.showForm = true;
    this.windowRef.blockScroll();
    this.popupService.openPopup(this.name, !!disableReload);

    showAfterSecond(100, this.loaded, this.changeDet);
    this.changeDet.detectChanges();
  }

  public onSubmit(): void
  {
    this.submitted = true;

    if (this.formGroup.invalid)
    {
      this.error = this.translate.instant("error.resetPasswordUnsuccessful");
      return;
    }
    this.isLoading = true;
    this.savedEmail = this.formGroup.get("email").value;
    this.passwordRecoveryService
      .recover(
        {
          email: this.formGroup.get("email").value,
        }
      )
      .subscribe(this.onSuccess.bind(this), this.onError.bind(this));
  }

  private buildForm(): void
  {
    this.formGroup = this.formBuilder.group({
      email: ["", [Validators.required, CustomValidators.email]],
    });
    this.formGroup = new UntypedFormGroup(this.formGroup.controls, {
      updateOn: "submit",
    });
  }

  private onSuccess(success: boolean): void
  {
    this.isLoading = false;

    if (success)
    {
      this.error = null;
      this.successMsg = this.translate.instant("error.changePasswordSuccessful");
      this.formGroup.reset();
      this.submitted = false;
      return;
    }

    this.successMsg = null;
    this.error = this.translate.instant("error.resetPasswordUnsuccessful");
  }

  private onError(error: LoginError): void
  {
    this.successMsg = "";
    this.error = error;
    this.isLoading = false;
  }

  public recoveryPasswordViaSms(): void { }

  public goToCreateAccountPage(): void
  {
    this.router.navigateByUrl(`/${this.urlTranslateService.urlMapping.customer.register}`);
  }

  public goToLoginPage(): void
  {
    this.router.navigateByUrl(`/${this.urlTranslateService.urlMapping.customer.login}`);
  }

  public closeModal(event?: any, disableReload?: boolean): void
  {
    if (!event || !event.target.className.includes("success-link"))
    {
      this.windowRef.unBlockScroll();
      this.showForm = false;
      this.loaded["loaded"] = false;
      this.popupService.closePopup(this.name, !!disableReload);

      this.changeDet.detectChanges();
    }
  }

  @HostListener("window:keyup", ["$event"])
  private onKeyUp(event): void
  {
    if (this.showForm && event.key === "Escape")
    {
      this.closeModal(null);
    } else if (this.showForm && event.keyCode === 13)
    {
      this.onSubmit();
    }
  }

  @HostListener("window:popstate", ['$event'])
  private backButtonHandler(): void
  {
    if (
      !this.popupService.isActiveParam("m", this.name) &&
      this.popupService.isActivePopup(this.name)
    )
    {
      this.closeModal(null, true);
    }
  }
}
